import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  MenuItem,
  Button,
  Box,
  FormControl,
  FormLabel,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
  useDisclosure
} from '@chakra-ui/react'
import { FC, useState } from 'react'

import useMrpDistribution from '@hook/mrp/use-distribution'
import useTools from '@hook/shared/use-tools'

import Filter from '@component/Shared/Filter'

import { ILayoutToolsExportAction } from '@base/@types/components/Layout/Tools'

const ActionDistribuitonMrpSAPExport: FC<ILayoutToolsExportAction> = ({
  data,
  sapModal
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const { handleUpdateSapParams, paramsSap, exportDataSapCsv, supplyMethod } =
    useMrpDistribution()
  const { isDisabled } = useTools()
  const [loading, setLoading] = useState(false)
  const unique = [...new Set(data.map(item => item.estoque.idEmpresa))]

  if (unique.length === 0) {
    return (
      <>
        <Modal
          isOpen={isOpen}
          onClose={onClose}
          motionPreset="slideInBottom"
          isCentered
        >
          <ModalOverlay />
          <ModalContent>
            <ModalHeader bgColor="white">Exportar para SAP/Viasoft</ModalHeader>
            <ModalCloseButton />
            <ModalBody bgColor="white">
              <Box w="100%">
                <FormControl id="discount">
                  <FormLabel>Desconto</FormLabel>
                  <NumberInput
                    borderColor="blackAlpha.400"
                    max={10000}
                    value={paramsSap.desconto}
                    onChange={value =>
                      handleUpdateSapParams({
                        name: 'desconto',
                        value
                      })
                    }
                  >
                    <NumberInputField />
                    <NumberInputStepper>
                      <NumberIncrementStepper />
                      <NumberDecrementStepper />
                    </NumberInputStepper>
                  </NumberInput>
                </FormControl>
              </Box>
              <br></br>
              <Filter
                label="Forma de Pagamento"
                options={supplyMethod.map(paymentMethod => ({
                  label: `${paymentMethod.codigo} - ${paymentMethod.descricao}`,
                  value: paymentMethod.codigo
                }))}
                value={paramsSap.metodoPagamento}
                isMulti
                onChange={value =>
                  handleUpdateSapParams({ name: 'metodoPagamento', value })
                }
              />
            </ModalBody>
            <ModalFooter bgColor="white">
              <Button
                variant="ghost"
                color="black"
                onClick={() => {
                  exportDataSapCsv()
                  onClose()
                }}
                isDisabled={!supplyMethod}
              >
                Exportar
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
        <MenuItem
          p="2px 12px"
          fontSize="sm"
          _hover={{ bg: 'gray.400' }}
          onClick={() => {
            onOpen()
            setLoading(false)
          }}
          isDisabled={isDisabled}
        >
          Exportar para SAP/Viasoft
        </MenuItem>
      </>
    )
  } else if (sapModal && data.length > 0 && loading) {
    exportDataSapCsv()
    setLoading(false)
  }

  return (
    <MenuItem
      p="2px 12px"
      fontSize="sm"
      bgColor="white"
      _hover={{ bg: 'gray.400' }}
      onClick={() => {
        setLoading(true)
        exportDataSapCsv()
      }}
      isDisabled={isDisabled}
    >
      Exportar para SAP/Viasoft
    </MenuItem>
  )
}

export default ActionDistribuitonMrpSAPExport
